import {getTutorialsSaga} from './get-tutorials-saga';

/** Shared layout sagas used by the shell. */
export const layoutSagas = [getTutorialsSaga];
